import { render, staticRenderFns } from "./salesAddressPopup.vue?vue&type=template&id=8976ca4c&scoped=true&"
import script from "./salesAddressPopup.vue?vue&type=script&lang=js&"
export * from "./salesAddressPopup.vue?vue&type=script&lang=js&"
import style0 from "./salesAddressPopup.vue?vue&type=style&index=0&lang=css&"
import style1 from "./salesAddressPopup.vue?vue&type=style&index=1&id=8976ca4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8976ca4c",
  null
  
)

export default component.exports